import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

const SignInOidc = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    navigate(`/`);
  }, []);

  return <div>Signing in...</div>;
};

export default SignInOidc;
